import React from 'react';
import PropTypes from 'prop-types';

const Tooltip = ({ tooltip }) => (
  <i aria-hidden="true" className="tip-on-hover relative question-tooltip padding-left-5px">
    <span className="tip d-none border padding-10px bg-white border-radius-5px box-shadow">
      <p className="text-tiny">{tooltip}</p>
    </span>
  </i>
);

Tooltip.propTypes = {
  tooltip: PropTypes.string.isRequired,
};

export default Tooltip;
